/* eslint-disable camelcase */
import * as firebase from 'firebase/app';

export function log(event_name, event_params) {
  firebase.analytics().logEvent(event_name, event_params);
}
